import   React        ,
       { useEffect    }  from 'react';

import   classNames   from 'classnames';

import   styles        from './payment_result.module.scss';

import { useNavigate }  from 'react-router-dom';

import { notifyPaymentResultToOpener }  from '../../../utils/utils_paymentPopup';

// Retour PayPal/Stripe après annulation/échec d'un paiement ou d'un abonnement initié
// depuis admin-front. Cf. payment_success.tsx pour le fonctionnement en fenêtre à part
// (window.opener) et le repli quand elle a été ouverte autrement.
export const PaymentFailure: React.FC = () => {

  const navigate = useNavigate();

  const openedAsPopup = !!window.opener;

  useEffect(() => {
    if (!openedAsPopup) return;

    notifyPaymentResultToOpener('failure');

    const timer = setTimeout(() => window.close(), 1500);
    return () => clearTimeout(timer);
  }, [openedAsPopup]);

  return (
    <div className={classNames(styles.root)}>
      <div className={classNames(styles.contain)}>
        <div className={classNames(styles.title)}>Paiement annulé</div>
        <div className={classNames(styles.text)}>Le paiement n'a pas abouti. Le panier n'a pas été modifié.</div>
        {
          openedAsPopup
          ? <div className={classNames(styles.text)}>Cette fenêtre va se refermer.</div>
          : (
            <button className={classNames(styles.button)} onClick={() => navigate('/bureau')}>
              Retour à mes achats
            </button>
          )
        }
      </div>
    </div>
  );
};

export default PaymentFailure;
